import * as themesAPI from "./themes-api";

export async function getThemes() {
  try {
    const response = await themesAPI.index();
    return response;
  } catch (err) {
    return err;
  }
}

export async function createTheme(data) {
  try {
    const response = await themesAPI.create(data);
    return response;
  } catch (err) {
    return err;
  }
}

export async function updateTheme(id, data) {
  try {
    const response = await themesAPI.update(id, data);
    return response;
  } catch (err) {
    return err;
  }
}

export async function deleteTheme(id) {
  try {
    const response = await themesAPI.remove(id);
    return response;
  } catch (err) {
    return err;
  }
}
